import React, { useEffect, useRef, useState } from "react";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { setIsSidebarOpen } from "../../redux/slices/app/app.slice";
import { getLanguagesRedux } from "../../redux/slices/languages/languages.asyncActions";
import { setLangTrue } from "../../redux/slices/languages/languages.slice";
import "./header.css";

const StyledBurger = styled.div`
    margin-top: 25px;
    width: 3.5rem;
    height: 20px;
    top: 15px;
    right: 20px;
    z-index: 20;
    display: none;

    @media (max-width: 991px) {
        display: flex;
        position: absolute;
        right: 5px;
        top: 0;
        justify-content: space-around;
        flex-flow: column nowrap;
        z-index: 3000;
    }
    @media (max-width: 615px) {
        right: -10px;
    }

    div {
        width: 1.5rem;
        height: 2px;
        background-color: ${({ open }) => (open ? "#ccc" : "#333")};
        border-radius: 10px;
        transform-origin: 1px;
        transition: all 0.3s linear;
        &:nth-child(1) {
            transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
        }
        &:nth-child(2) {
            transform: ${({ open }) =>
                open ? "translateX(100%)" : "translateX(0)"};
            opacity: ${({ open }) => (open ? 0 : 1)};
        }
        &:nth-child(3) {
            transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
        }
    }
`;

function Burger() {
    const dispatch = useDispatch();

    const [icon, setIcon] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [lang, setLang] = useState("en");
    const isReqTrue = useSelector((state) => state.languagesState.isReqTrue);
    const isSidebarOpen = useSelector((state) => state.app.isSidebarOpen);

    const iconRef = useRef(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (isReqTrue) {
            getLang();
        }
    }, [lang]);

    const getLang = () => {
        dispatch(getLanguagesRedux(lang));
    };

    const handleSetLang = (value) => {
        dispatch(setLangTrue());
        setLang(value);
    };

    const handleClickOutside = (event) => {
        if (
            isOpen &&
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            !iconRef.current.contains(event.target)
        ) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <div className="header-part-right">
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={menuOpen}
                    onClose={handleClose}
                    MenuListProps={{
                        "aria-labelledby": "basic-button",
                    }}
                >
                    <MenuItem onClick={() => handleSetLang("en")}>
                        English
                    </MenuItem>
                </Menu>
                <StyledBurger
                    className="hamburger-icon"
                    open={isSidebarOpen}
                    onClick={() => {
                        dispatch(setIsSidebarOpen(!isSidebarOpen));
                        setIcon(!icon);
                    }}
                >
                    <div className={isSidebarOpen ? "div-in-burger" : null} />
                    <div className={isSidebarOpen ? "div-in-burger" : null} />
                    <div className={isSidebarOpen ? "div-in-burger" : null} />
                    <button className="hidden-button" hidden={icon}>
                        <FontAwesomeIcon
                            icon={faTimes}
                            className="fa-lg"
                            style={{ color: "black" }}
                        />
                    </button>
                </StyledBurger>
            </div>
        </>
    );
}

export default Burger;
